import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.states';

export const getUserState = createFeatureSelector<AppState>('user');
export const getAdminuserState = createFeatureSelector<AppState>('adminuser');

export const getUserInfo = createSelector(
  getUserState,
  (state: AppState) => state.user
);
export const getAdminUserInfo = createSelector(
  getAdminuserState,
  (state: AppState) => state.adminuser
);
